import { render, staticRenderFns } from "./WorkConsideration.vue?vue&type=template&id=896e1f0a&scoped=true"
import script from "./WorkConsideration.vue?vue&type=script&lang=js"
export * from "./WorkConsideration.vue?vue&type=script&lang=js"
import style0 from "./WorkConsideration.vue?vue&type=style&index=0&id=896e1f0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896e1f0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('896e1f0a')) {
      api.createRecord('896e1f0a', component.options)
    } else {
      api.reload('896e1f0a', component.options)
    }
    module.hot.accept("./WorkConsideration.vue?vue&type=template&id=896e1f0a&scoped=true", function () {
      api.rerender('896e1f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customize/Front/IDL/WorkConsideration.vue"
export default component.exports